import { render, staticRenderFns } from "./SalaryDetailList.vue?vue&type=template&id=2eb137f4&scoped=true"
import script from "./SalaryDetailList.vue?vue&type=script&lang=js"
export * from "./SalaryDetailList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2eb137f4",
  null
  
)

export default component.exports